/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCreateRoomVideoCredentialsRequestFromJSON(json) {
    return StreemApiCreateRoomVideoCredentialsRequestFromJSONTyped(json, false);
}
export function StreemApiCreateRoomVideoCredentialsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'preflight': !exists(json, 'preflight') ? undefined : json['preflight'],
        'mediaRegion': !exists(json, 'media_region') ? undefined : json['media_region'],
    };
}
export function StreemApiCreateRoomVideoCredentialsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'preflight': value.preflight,
        'media_region': value.mediaRegion,
    };
}
//# sourceMappingURL=StreemApiCreateRoomVideoCredentialsRequest.js.map